/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Profile_Update_Workout_BodyInputs */

const en_us2_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} is downloaded. A workout is in progress, so it opens the next time you open the app.`)
};

const pt_br2_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A versão ${i?.version} já foi baixada. Como há um treino em andamento, ela abre na próxima vez que você abrir o app.`)
};

const es_419_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La versión ${i?.version} ya se descargó. Como hay un entrenamiento en curso, se abrirá la próxima vez que abras la app.`)
};

const pt_pt2_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A versão ${i?.version} já foi transferida. Como há um treino a decorrer, abre da próxima vez que abrires a app.`)
};

const fr_fr2_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La version ${i?.version} est téléchargée. Une séance est en cours, elle s'ouvrira donc la prochaine fois que tu ouvriras l'app.`)
};

const de_de2_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} ist heruntergeladen. Da ein Training läuft, öffnet sie sich beim nächsten Start der App.`)
};

const it_it2_profile_update_workout_body = /** @type {(inputs: Profile_Update_Workout_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La versione ${i?.version} è stata scaricata. C'è un allenamento in corso, quindi si aprirà la prossima volta che apri l'app.`)
};

/**
* | output |
* | --- |
* | "Version {version} is downloaded. A workout is in progress, so it opens the next time you open the app." |
*
* @param {Profile_Update_Workout_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_workout_body = /** @type {((inputs: Profile_Update_Workout_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_Workout_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_workout_body(inputs)
	if (locale === "es-419") return es_419_profile_update_workout_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_workout_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_workout_body(inputs)
	if (locale === "de-DE") return de_de2_profile_update_workout_body(inputs)
	if (locale === "it-IT") return it_it2_profile_update_workout_body(inputs)
	return en_us2_profile_update_workout_body(inputs)
});
export { profile_update_workout_body as "profile.update_workout_body" }